import { render, staticRenderFns } from "./SuperCampaignModal.vue?vue&type=template&id=2dbddb01&"
import script from "./SuperCampaignModal.vue?vue&type=script&lang=js&"
export * from "./SuperCampaignModal.vue?vue&type=script&lang=js&"
import style0 from "./SuperCampaignModal.vue?vue&type=style&index=0&id=2dbddb01&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports